import { useEffect, useRef } from "react";

// Soft glow that trails the system cursor. The native cursor stays visible;
// this is only an ambient light halo underneath it. Hidden on touch devices.
export default function CustomCursor() {
  const glow = useRef(null);
  const raf = useRef(0);
  const target = useRef({ x: -200, y: -200 });
  const current = useRef({ x: -200, y: -200 });

  useEffect(() => {
    if (typeof window === "undefined" || matchMedia("(pointer: coarse)").matches) return;

    document.documentElement.classList.add("has-cursor-glow");

    const onMove = (e) => {
      target.current.x = e.clientX;
      target.current.y = e.clientY;
    };

    const onOver = (e) => {
      const interactive = e.target.closest(
        "a, button, [role=button], [data-interactive], input, textarea, select, iframe, label"
      );
      if (glow.current) {
        glow.current.classList.toggle("cursor-glow--hover", !!interactive);
      }
    };

    const loop = () => {
      current.current.x += (target.current.x - current.current.x) * 0.22;
      current.current.y += (target.current.y - current.current.y) * 0.22;
      if (glow.current) {
        glow.current.style.transform = `translate3d(${current.current.x - 60}px, ${current.current.y - 60}px, 0)`;
      }
      raf.current = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver);
    raf.current = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf.current);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      document.documentElement.classList.remove("has-cursor-glow");
    };
  }, []);

  return (
    <div ref={glow} className="prulo-cursor-glow" data-testid="cursor-glow" aria-hidden="true" />
  );
}
